var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.$style.title},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.type === 1 ? true : false)?_c('div',{class:_vm.$style.back,on:{"click":_vm.backTo}},[_c('img',{attrs:{"src":_vm.back,"alt":""}})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }